(function () {
  'use strict';

  var VOTE_KEY = 'ap_review_votes';
  var PER_PAGE = 6;

  function readVotes() {
    try {
      return JSON.parse(localStorage.getItem(VOTE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeVotes(v) {
    try {
      localStorage.setItem(VOTE_KEY, JSON.stringify(v));
    } catch (e) {}
  }

  /* ---------- Truncated page range ---------- */
  function paginationRange(current, total, sibling) {
    if (typeof sibling === 'undefined') sibling = 1;

    var limit = 7 + sibling * 2;
    if (total <= limit) {
      var all = [];
      for (var n = 1; n <= total; n++) all.push(n);
      return all;
    }

    var left  = Math.max(current - sibling, 1);
    var right = Math.min(current + sibling, total);

    var showLeftDots  = left > 3;
    var showRightDots = right < total - 2;

    var pages = [1, 2];

    if (showLeftDots) {
      pages.push('dots');
    } else {
      for (var i = 3; i < left; i++) pages.push(i);
    }

    for (var j = left; j <= right; j++) {
      if (pages.indexOf(j) === -1) pages.push(j);
    }

    if (showRightDots) {
      pages.push('dots');
    } else {
      for (var k = right + 1; k < total - 1; k++) pages.push(k);
    }

    if (pages.indexOf(total - 1) === -1) pages.push(total - 1);
    if (pages.indexOf(total) === -1)     pages.push(total);

    return pages;
  }

  var TINTS = ['y', 'r', 't', ''];
  var ETSY_SRC = 'https://www.etsy.com/shop/AnimePass?ref=dashboard-header#reviews';

  function buildCard(d, idx, tVerified, tHelpful, tViewProduct) {
    var el = document.createElement('article');
    el.className = 'rv-card';
    el.setAttribute('data-ap-review', '');
    if (d.k) el.setAttribute('data-ap-key', d.k);
    el.setAttribute('data-ap-rating', d.r);
    el.setAttribute('data-ap-photos', 'false');
    el.setAttribute('data-ap-helpful', d.h || 0);

    var parts = d.d.split('-');
    var ts = parts.length === 3
      ? new Date(+parts[0], +parts[1] - 1, +parts[2]).getTime() / 1000
      : 0;
    el.setAttribute('data-ap-date', Math.round(ts));

    var initial = (d.a || '?').charAt(0).toUpperCase();
    var tint = TINTS[idx % 4];
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += i <= d.r ? '★' : '☆';

    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var dateStr = '';
    if (parts.length === 3) {
      dateStr = months[+parts[1] - 1] + ' ' + (+parts[2]) + ', ' + parts[0];
    }

    var html = '<div class="rv-head"><div class="rv-left">' +
      '<div class="rv-ava ' + tint + '" aria-hidden="true">' + initial + '</div><div>' +
      '<div class="rv-name">' + esc(d.a) + '</div>';

    if (d.s === 'csv') {
      html += '<div class="rv-ver">' + tVerified + '</div>';
    }
    html += '</div></div>';

    if (dateStr) {
      html += '<div class="rv-meta"><time datetime="' + d.d + '">' + dateStr + '</time></div>';
    }
    html += '</div>';

    html += '<div class="rv-stars" aria-hidden="true"><span>' + stars + '</span></div>';

    if (d.t) html += '<h3 class="rv-title">' + esc(d.t) + '</h3>';
    if (d.b) html += '<p class="rv-body">' + esc(d.b) + '</p>';

    if (d.pt || d.pu) {
      html += '<div class="rv-tags">';
      if (d.pu) {
        html += '<a href="' + esc(d.pu) + '" class="rv-pill cov">' + esc(d.pt || '') + '</a>';
      } else if (d.pt) {
        html += '<span class="rv-pill cov">' + esc(d.pt) + '</span>';
      }
      html += '</div>';
    }

    html += '<div class="rv-foot"><div class="rv-helpful">' +
      '<span>' + tHelpful + '</span>' +
      '<button type="button" data-ap-vote="' + esc(d.k) + '" data-ap-vote-base="' + (d.h || 0) + '" aria-pressed="false">' +
      '👍 <span data-ap-vote-count>' + (d.h || 0) + '</span></button></div>';

    if (d.s === 'csv' && d.pu) {
      html += '<a href="' + esc(d.pu) + '" class="rv-product-link">' + tViewProduct + ' →</a>';
    } else if (d.s === 'etsy') {
      html += '<a href="' + esc(ETSY_SRC) + '" class="rv-source-link" target="_blank" rel="noopener noreferrer">Etsy ↗</a>';
    }

    html += '</div>';
    el.innerHTML = html;
    return el;
  }

  function esc(s) {
    if (!s) return '';
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function initCore(root) {
    var list = root.querySelector('[data-ap-review-list]');
    if (!list) return;
    if (root.getAttribute('data-ap-loaded')) return;
    root.setAttribute('data-ap-loaded', '1');

    /* ----------------------------------------------------------------
       Data-driven rendering. The full review set (all 894, seeds
       included) is fetched lazily from <path>?view=reviews-data — a
       {% layout none %} template that emits the array for the current
       locale — so the ~250 KB blob is NOT inlined in the page HTML.
       We dedupe by key, shuffle once, then filter/sort/paginate the
       ARRAY, rendering only the current page. The 24 server-rendered
       seed cards stay (for no-JS/crawlers and to hold the section's
       height) until the fetch resolves, then render() replaces them.
       On fetch failure the seed cards remain.
    ---------------------------------------------------------------- */
    /* No Accept:application/json header — on product URLs that triggers
       Shopify's content negotiation and returns the product object instead of
       our ?view=reviews-data template output. */
    fetch(location.pathname + '?view=reviews-data')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (raw) { if (raw && raw.length) buildList(root, list, raw); })
      .catch(function () {});
  }

  function buildList(root, list, raw) {
    var seen = {};
    var DATA = [];
    for (var r = 0; r < raw.length; r++) {
      var d = raw[r];
      if (!d) continue;
      if (d.k) {
        if (seen[d.k]) continue;
        seen[d.k] = true;
      }
      var parts = (d.d || '').split('-');
      d._ts = parts.length === 3
        ? new Date(+parts[0], +parts[1] - 1, +parts[2]).getTime() / 1000
        : 0;
      d._tint = DATA.length; /* stable tint index across re-renders */
      DATA.push(d);
    }

    /* If the blob was missing (shouldn't happen), keep whatever seed
       cards are in the DOM rather than blanking the list. */
    if (DATA.length === 0) return;

    /* Drop the server-rendered seed cards — their data is in DATA. */
    list.querySelectorAll('[data-ap-review]').forEach(function (el) { el.remove(); });

    /* Shuffle once (Fisher-Yates) so Etsy + CSV interleave. */
    for (var si = DATA.length - 1; si > 0; si--) {
      var sj = Math.floor(Math.random() * (si + 1));
      var tmp = DATA[si]; DATA[si] = DATA[sj]; DATA[sj] = tmp;
    }

    var tVerified = root.getAttribute('data-t-verified') || 'Verified buyer';
    var tHelpful = root.getAttribute('data-t-helpful') || 'Was this helpful?';
    var tViewProduct = root.getAttribute('data-t-view-product') || 'View product';
    var tNoReviews = root.getAttribute('data-t-no-reviews') || 'No reviews found.';

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ap-review-filter]'));
    var sortSel = root.querySelector('[data-ap-review-sort]');
    var empty = root.querySelector('[data-ap-review-empty]');
    var statusEl = root.querySelector('[data-ap-review-status]');

    var active = 'all';
    var sortMode = '';       /* '' = shuffled order (initial) */
    var currentPage = 1;
    var initialized = false;
    var votes = readVotes();

    /* ---------- Filter / sort the array ---------- */
    function passes(d, filter) {
      var rating = d.r || 0;
      switch (filter) {
        case 'all':      return true;
        case '5':        return rating === 5;
        case '4':        return rating === 4;
        case 'critical': return rating > 0 && rating <= 3;
        case 'photo':    return false;
        default:         return true;
      }
    }

    function currentList() {
      var arr = DATA.filter(function (d) { return passes(d, active); });
      switch (sortMode) {
        case 'recent':  arr.sort(function (a, b) { return b._ts - a._ts; }); break;
        case 'highest': arr.sort(function (a, b) { return b.r - a.r; }); break;
        case 'lowest':  arr.sort(function (a, b) { return a.r - b.r; }); break;
        case 'helpful': arr.sort(function (a, b) { return (b.h || 0) - (a.h || 0); }); break;
        default: break; /* keep shuffled order */
      }
      return arr;
    }

    /* ---------- Pagination ---------- */
    var pagContainer = null;

    function buildPagination(totalItems) {
      if (pagContainer) { pagContainer.remove(); pagContainer = null; }
      var totalPages = Math.ceil(totalItems / PER_PAGE);
      if (totalPages <= 1) return;

      pagContainer = document.createElement('nav');
      pagContainer.className = 'rv-pag';
      pagContainer.setAttribute('aria-label', 'Review pages');

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'pg pg-arrow';
      prev.textContent = '←';
      prev.setAttribute('aria-label', 'Previous page');
      prev.disabled = currentPage === 1;
      prev.addEventListener('click', function () { goPage(currentPage - 1); });
      pagContainer.appendChild(prev);

      var range = paginationRange(currentPage, totalPages);
      for (var i = 0; i < range.length; i++) {
        var p = range[i];
        if (p === 'dots') {
          var dots = document.createElement('span');
          dots.className = 'pg-dots';
          dots.textContent = '…';
          pagContainer.appendChild(dots);
        } else {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'pg' + (p === currentPage ? ' active' : '');
          btn.textContent = p;
          btn.setAttribute('aria-label', 'Page ' + p);
          if (p === currentPage) btn.setAttribute('aria-current', 'page');
          (function (page) {
            btn.addEventListener('click', function () { goPage(page); });
          })(p);
          pagContainer.appendChild(btn);
        }
      }

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'pg pg-arrow';
      next.textContent = '→';
      next.setAttribute('aria-label', 'Next page');
      next.disabled = currentPage === totalPages;
      next.addEventListener('click', function () { goPage(currentPage + 1); });
      pagContainer.appendChild(next);

      list.parentNode.insertBefore(pagContainer, list.nextSibling);
    }

    function goPage(page) {
      currentPage = page;
      render();
      var bar = root.querySelector('.rv-bar') || root;
      var motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      bar.scrollIntoView({ behavior: motionOk ? 'smooth' : 'auto', block: 'start' });
    }

    function announceResults(count) {
      if (!statusEl) return;
      var msg = count === 0 ? tNoReviews : count + '+';
      statusEl.textContent = '';
      requestAnimationFrame(function () { statusEl.textContent = msg; });
    }

    /* ---------- Render only the current page ---------- */
    function render() {
      var arr = currentList();
      var totalPages = Math.ceil(arr.length / PER_PAGE);
      if (currentPage > totalPages && totalPages > 0) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;

      var start = (currentPage - 1) * PER_PAGE;
      var pageItems = arr.slice(start, start + PER_PAGE);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < pageItems.length; i++) {
        var d = pageItems[i];
        var card = buildCard(d, d._tint, tVerified, tHelpful, tViewProduct);
        if (d.k && votes[d.k]) {
          var vb = card.querySelector('[data-ap-vote]');
          if (vb) {
            vb.setAttribute('aria-pressed', 'true');
            var vc = vb.querySelector('[data-ap-vote-count]');
            if (vc) vc.textContent = (d.h || 0) + 1;
          }
        }
        frag.appendChild(card);
      }

      list.innerHTML = '';
      list.appendChild(frag);

      if (empty) empty.hidden = arr.length > 0;
      buildPagination(arr.length);
      if (initialized) announceResults(arr.length);
    }

    /* ---------- Chips (keep the Liquid-rendered counts as-is) ---------- */
    chips.forEach(function (chip) {
      var f = chip.getAttribute('data-ap-review-filter');
      chip.addEventListener('click', function () {
        active = f;
        currentPage = 1;
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        render();
      });
    });

    /* ---------- Sorting ---------- */
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        sortMode = sortSel.value;
        currentPage = 1;
        render();
      });
    }

    /* ---------- Helpful votes (delegated, keyed on data-ap-key) ----------
       Delegation on root survives list re-renders and also covers the
       server-rendered featured review's vote button. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ap-vote]');
      if (!btn || !root.contains(btn)) return;
      var key = btn.getAttribute('data-ap-vote');
      var base = parseInt(btn.getAttribute('data-ap-vote-base'), 10) || 0;
      var countEl = btn.querySelector('[data-ap-vote-count]');
      var on = !votes[key];
      if (on) { votes[key] = 1; } else { delete votes[key]; }
      writeVotes(votes);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (countEl) countEl.textContent = on ? base + 1 : base;
    });

    /* Apply persisted vote state to any vote button outside the list
       (e.g. the featured review), which render() does not rebuild. */
    root.querySelectorAll('[data-ap-vote]').forEach(function (btn) {
      if (list.contains(btn)) return;
      var key = btn.getAttribute('data-ap-vote');
      if (!votes[key]) return;
      var base = parseInt(btn.getAttribute('data-ap-vote-base'), 10) || 0;
      var countEl = btn.querySelector('[data-ap-vote-count]');
      btn.setAttribute('aria-pressed', 'true');
      if (countEl) countEl.textContent = base + 1;
    });

    render();
    initialized = true;
  }

  /* ---------- IntersectionObserver gate ---------- */
  function init(root) {
    if (!('IntersectionObserver' in window)) {
      initCore(root);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          observer.disconnect();
          initCore(root);
          return;
        }
      }
    }, { rootMargin: '600px' });

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-ap-reviews-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ap-reviews-page]');
    if (root) init(root);
  });
})();
